export const fileSize = (node) => {
    const maxSize = 50000000;

    // FormKit file inputs hold [{ name, file }]. Nothing selected (or a pre-existing file with no File
    // object, e.g. an already-uploaded document) has no size to check, so let `required` handle emptiness.
    const files = Array.isArray(node.value) ? node.value : [];
    const size = files[0]?.file?.size;
    if (typeof size !== 'number') return true;

    return size < maxSize;
}
